// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1jOf3","contentOuter":"_1GORv","heading":"_1Sukb","detail":"R7QAE"};